import React, {FC} from 'react'

import RamblerFooter from '@rambler-components/footer'
import '@rambler-components/footer/styles.css'
import {MENU_LINKS, SOCIAL_LINKS} from 'utils/constants'

export const Footer: FC = () => (
  <RamblerFooter
    type="dark"
    socialLinks={SOCIAL_LINKS}
    simpleLinks={MENU_LINKS}
  />
)
